import React from 'react';

const ComponentChangeLanguage = () => {
  return (
    <div>
      ComponentChangeLanguage
    </div>
  );
};

export default ComponentChangeLanguage;